import Icon from "@mui/material/Icon";
import MDBadge from "../../../../components/MDBadge";
import {useEffect, useMemo, useState} from "react";
import {getAmenities, getAmenitiesType} from "../../../../services/amenities.service";
import GHIconButton from "../../../../components/GHIconButton";

export function useAmenitiesTypeTable(clickItem) {

  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Name", accessor: "name", width: "20%" },
    { Header: "Amenity Count", accessor: "amenityCount", width: "20%" },
    { Header: "Parent", accessor: "parent", width: "25%" },
    { Header: "Actions", accessor: "action", width: "7%" },
  ];

  useEffect(() => {
    getAmenitiesType()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns,
    rows: rows
      ? rows.map((element) => ({
          id: element.id,
          name: element.amenity_type,
          parent: element.parent?.amenity_type || "", 
          amenityCount: element.size,
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}

